<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <div class="con-vs-tabs vs-tabs vs-tabs-primary vs-tabs-position-top">
        <div class="con-ul-tabas">
          <ul class="ul-tabs vs-tabs--ul ul-tabs-left">
            <li class="vs-tabs--li" :class="passo === 0 ? 'activeChild' : ''">
              <button @click="passo = 0" type="button" class="vs-tabs--btn">
                <span>Geral</span>
              </button>
            </li>
            <li class="vs-tabs--li" :class="passo === 1 ? 'activeChild' : ''">
              <button @click="passo = 1" type="button" class="vs-tabs--btn">
                <span>Avançado</span>
              </button>
            </li>
          </ul>
        </div>
        <!-- Tab body Geral -->
        <div :class="passo === 0 ? 'div-show' : 'div-hide'">
          <div class="vx-row mb-6 mt-5">
            <div class="vx-col w-full">
              <span>Nome</span>
              <vs-input
                size="large"
                class="w-full"
                name="Nome"
                id="Nome"
                v-model="formCadastro.nomeProduto"
                v-validate="{ required: true, min: 3 }"
                :state="validateState('Nome')"
                :danger="validateClass('Nome')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
              />
            </div>
          </div>

          <div class="vx-row mb-6 mt-5">
            <div class="vx-col w-full">
              <span>Nome Resumido</span>
              <vs-input
                size="large"
                class="w-full"
                name="Nome Resumido"
                id="Nome Resumido"
                v-model="formCadastro.nomeProdutoResumo"
                v-validate="{ required: true, min: 3 }"
                :state="validateState('Nome Resumido')"
                :danger="validateClass('Nome Resumido')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <span>Tipo de Produto</span>

              <vs-select
                v-model="formCadastro.idTipoProduto"
                class="select-large w-full"
                name="Tipo de Produto"
                v-validate="{ required: true }"
                :state="validateState('Tipo de Produto')"
                :danger="validateClass('Tipo de Produto')"
                @input="selecionaTipo()"
              >
                <vs-select-item
                  :key="index"
                  :value="item.id"
                  :text="item.label"
                  v-for="(item, index) in tipoProdutos"
                />
              </vs-select>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div v-if="formCadastro.idTipoProduto == 1" class="vx-col w-1/2">
              <span>Percentual Baseado Fipe</span>

              <money
                class="w-full vs-inputx vs-input--input large"
                name="Percentual Fipe"
                v-model.lazy="formCadastro.valorBaseadoFipe"
                v-money="money"
                id="Percentual Fipe"
                v-model="formCadastro.valorBaseadoFipe"
                v-validate="{ required: true }"
                :state="validateState('Percentual Fipe')"
                :danger="validateClass('Percentual Fipe')"
              ></money>
            </div>
            <div
              :class="`vx-col ${
                formCadastro.idTipoProduto == 1 ? 'w-1/2' : 'w-full'
              }`"
            >
              <span>Percentual de Desconto Máximo</span>
              <vs-input
                type="number"
                size="large"
                class="w-full"
                name="Percentual de Desconto"
                id="Percentual de Desconto"
                v-model="formCadastro.porcentagemDescontoMaxima"
                v-validate="{ required: true }"
                :state="validateState('Percentual de Desconto')"
                :danger="validateClass('Percentual de Desconto')"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
              />
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col mb-6">
              <span>Valor Fixo ou Tabelado</span>
              <vs-switch
                color="success"
                v-model="formCadastro.isValorFixo"
                style="width: 80px"
              >
                <span slot="on">Fixo</span>
                <span slot="off">Tabelado</span>
              </vs-switch>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col mb-6">
              <span>É serviço?</span>
              <vs-switch
                color="success"
                v-model="formCadastro.isServico"
                style="width: 80px"
              >
                <span slot="on">Sim</span>
                <span slot="off">Não</span>
              </vs-switch>
            </div>
          </div>

          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <span>Grupos</span>
              <v-select
                :options="grupos"
                name="Grupos"
                id="Grupos"
                v-model="grupo"
                :state="validateState('Grupos')"
                :class="validateClass('Grupos')"
              ></v-select>
              <br />
              <vs-list-item
                v-for="item in gruposVeiculos"
                :key="item.idGrupo"
                :title="item.nomeGrupo"
                :subtitle="exibeValor(item.valor)"
              >
                <template slot="avatar">
                  <vs-button
                    @click="deletaGrupoVeiculo(item.idGrupo)"
                    class="mr-2"
                    color="primary"
                    type="border"
                    icon="clear"
                  ></vs-button>
                </template>
              </vs-list-item>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <span>Tipos de Descontos</span>
              <v-select
                :options="tiposDeDescontos"
                name="tiposDeDescontos"
                id="tiposDeDescontos"
                v-model="tiposDescontos"
              ></v-select>
              <br />

              <vs-list-item
                v-for="item in DescontoEscolhido"
                :key="item.idTipoDesconto"
                :title="item.descricao"
                :subtitle="item.status"
              >
                <div></div>

                <span>{{ item.percentualMaximoDesconto }}%</span>
                <template slot="avatar">
                  <vs-button
                    @click="deletaTipoDesconto(item.idTipoDesconto)"
                    class="mr-2"
                    color="primary"
                    type="border"
                    icon="clear"
                  ></vs-button>
                </template>
              </vs-list-item>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <span>Formas de Pagamento</span>
              <v-select
                :options="formasPagamentos"
                name="Formas de Pagamento"
                id="Formas de Pagamento"
                v-model="formCadastro.formasPagamentos"
                multiple
                v-validate="{ required: true }"
                :state="validateState('Formas de Pagamento')"
                :class="validateClass('Formas de Pagamento')"
                danger-text="Preencha este Campo"
              ></v-select>
              <small>Selecione uma ou mais</small>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <span>Produtos Linkados</span>
              <v-select
                :options="produtos"
                name="Produtos Linkados"
                id="Produtos Linkados"
                v-model="formCadastro.produtosLinkados"
                multiple
                :state="validateState('Produtos Linkados')"
                :class="validateClass('Produtos Linkados')"
              ></v-select>
              <small>Selecione um ou mais</small>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <span>Sobrepõe outros Produtos</span>
              <v-select
                :options="produtos"
                name="Sobrepõe outros Produtos"
                id="Sobrepõe outros Produtos"
                v-model="formCadastro.sobreporOutrosProdutos"
                multiple
                :state="validateState('Sobrepõe outros Produtos')"
                :class="validateClass('Sobrepõe outros Produtos')"
              ></v-select>
              <small>Selecione um ou mais</small>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <span>Aplicar produto para:</span>
              <v-select
                :options="destinos"
                name="destinos"
                id="destinos"
                multiple
                v-model="formCadastro.destinos"
              ></v-select>
              <small>Selecione uma ou mais</small>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <span>Este é um Produto Evo?</span>

              <vs-select
                v-model="formCadastro.idProdutoEvo"
                class="select-large w-full"
                name="Produto Evo"
                :state="validateState('Produto Evo')"
                :danger="validateClass('Produto Evo')"
              >
                <vs-select-item
                  :key="index"
                  :value="item.id"
                  :text="item.label"
                  v-for="(item, index) in produtosEvo"
                />
              </vs-select>
            </div>
          </div>

          <div class="vx-row mb-6" v-if="fornecedoresFiltred.length > 0">
            <div class="vx-col w-full">
              <span>Fornecedor</span>

              <vs-select
                v-model="formCadastro.idFornecedor"
                class="select-large w-full"
                name="Fornecedor"
                :state="validateState('Fornecedor')"
                :danger="validateClass('Fornecedor')"
              >
                <vs-select-item
                  :key="index"
                  :value="item.id"
                  :text="item.label"
                  v-for="(item, index) in fornecedoresFiltred"
                />
              </vs-select>
            </div>
          </div>
          <div class="vx-row mt-3 mb-6">
            <div class="vx-col w-full">
              <vs-input
                class="w-full"
                type="number"
                step="0.00001"
                min="0"
                label="Valor Segurado"
                v-model="formCadastro.valorSegurado"
                id="Valor Segurado"
                name="Valor Segurado"
                v-validate="{ required: true }"
                :state="validateState('Valor Segurado')"
                :class="validateClass('Valor Segurado')"
              />
            </div>
          </div>
          <div class="vx-row mt-3 mb-6">
            <div class="vx-col w-full">
              <vs-input
                class="w-full"
                type="number"
                step="0.00001"
                min="0"
                label="franquia"
                v-model="formCadastro.franquia"
                id="franquia"
                name="franquia"
                v-validate="{ required: true }"
                :state="validateState('franquia')"
                :class="validateClass('franquia')"
              />
            </div>
          </div>
          <div class="vx-row mt-3 mb-6">
            <div class="vx-col w-full">
              <vs-input
                class="w-full"
                type="number"
                step="0.00001"
                min="0"
                label="IOF"
                v-model="formCadastro.IOF"
                id="IOF"
                name="IOF"
                v-validate="{ required: true }"
                :state="validateState('IOF')"
                :class="validateClass('IOF')"
              />
            </div>
          </div>
        </div>

        <!-- Avançado -->
        <div :class="passo === 1 ? 'div-show' : 'div-hide'">
          <div class="vx-row firstInputTab">
            <div class="vx-col mb-6">
              <span>Ativo</span>
              <vs-switch
                color="success"
                v-model="formCadastro.status"
                style="width: 60px"
              >
                <span slot="on">Ativo</span>
                <span slot="off">Inativo</span>
              </vs-switch>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col mb-6">
              <span>Obrigatório na Proposta</span>
              <vs-switch
                color="success"
                v-model="formCadastro.obrigatorio"
                style="width: 60px"
              >
                <span slot="on">Sim</span>
                <span slot="off">Não</span>
              </vs-switch>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col mb-6">
              <span>Valor Cobrado Mensalmente</span>
              <vs-switch
                color="success"
                v-model="formCadastro.isMensal"
                style="width: 60px"
              >
                <span slot="on">Sim</span>
                <span slot="off">Não</span>
              </vs-switch>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col mb-6">
              <span>Valor visível da Proposta</span>
              <vs-switch
                color="success"
                v-model="formCadastro.visivelProposta"
                style="width: 60px"
              >
                <span slot="on">Sim</span>
                <span slot="off">Não</span>
              </vs-switch>
            </div>
          </div>

          <!--div class="vx-row">
          <div class="vx-col mb-6">
            <span>Produto de Desconto?</span>
            <vs-switch
              color="success"
              v-model="formCadastro.isDesconto"
              style="width: 60px"
            >
              <span slot="on">Sim</span>
              <span slot="off">Não</span>
            </vs-switch>
          </div>
        </div-->

          <div class="vx-row">
            <div class="vx-col mb-6">
              <span>Produto Adicional (fora da proposta)</span>
              <vs-switch
                color="success"
                v-model="formCadastro.isAdicional"
                style="width: 60px"
              >
                <span slot="on">Sim</span>
                <span slot="off">Não</span>
              </vs-switch>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col mb-6">
              <span>Em caso de remoção exige Assinatura de Termo?</span>
              <vs-switch
                color="success"
                v-model="formCadastro.requerAssinaturaTermoAdicional"
                style="width: 60px"
              >
                <span slot="on">Sim</span>
                <span slot="off">Não</span>
              </vs-switch>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col mb-6">
              <span>Produto aparece na proposta?</span>
              <vs-switch
                color="success"
                v-model="formCadastro.produtoVisivel"
                style="width: 60px"
                id="produtoVisivel"
                name="produtoVisivel"
              >
                <span slot="on">Sim</span>
                <span slot="off">Não</span>
              </vs-switch>
            </div>
          </div>

          <div class="vx-row" v-if="bemProtege">
            <div class="vx-col mb-6">
              <span>Produto pode ter seu valor alterado na Cotação?</span>
              <vs-switch
                color="success"
                v-model="formCadastro.alterarValor"
                style="width: 60px"
                id="alterarValor"
                name="alterarValor"
              >
                <span slot="on">Sim</span>
                <span slot="off">Não</span>
              </vs-switch>
            </div>
          </div>
        </div>
      </div>

      <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->

      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>

      <!-- botões de cancelar salvar -->
      <div class="vx-row mb-5">
        <div class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="onReset"
            >Cancelar</vs-button
          >
          <BotaoSubmit
            variant="success"
            :edit="this.dados.idProduto == null ? false : true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>

      <div class="mt-6 mb-6"></div>

      <Modal
        class="holamundo"
        title="Informações de Valor do Produto"
        @cancel="clearFormGrupo"
        @accept="adicionaGrupoProduto"
        :active.sync="activePromptValor"
      >
        <div>
          Informe o Valor deste produto para o Grupo
          <b>{{ preencheGrupo() }}</b
          >.
          <vs-input
            placeholder="Valor"
            v-money="money"
            v-model="valorGrupo"
            name="Valor do produto"
            id="Valor do produto"
            class="mt-4 mb-2 w-full"
            v-validate="{ required: true, min: 0 }"
            :state="validateState('Valor do produto')"
            :class="validateClass('Valor do produto')"
          />
          <vs-button
            color="success"
            class="w-full mt-2"
            @click="adicionaGrupoProduto"
            >Salvar</vs-button
          >
        </div>
      </Modal>

      <Modal
        class="holamundo"
        title="Informações do Percentual do Desconto"
        :active.sync="activePromptDesconto"
        @cancel="clearFormDescontos"
      >
        <div>
          Informe o percentual para o tipo de desconto:
          <b>{{ preencheTipoDesconto() }}</b
          >.

          <div
            v-if="tiposDescontos.id == 4 || tiposDescontos.id == 5"
            class="vx-row mb-2 mt-4"
          >
            <div class="vx-col w-full">
              Selecione os estados:
              <v-select
                class="mt-3 mb-2"
                :options="estados"
                name="Estado"
                id="Estado"
                v-model="estado"
                :reduce="(item) => item.label"
                multiple
              ></v-select>
              <br />
            </div>
          </div>

          <div v-if="tiposDescontos.id == 2" class="vx-row mb-2 mt-4">
            <div class="vx-col w-full">
              Selecione o tipo de proposta:
              <v-select
                class="mt-3 mb-2"
                :options="tiposProposta"
                name="TiposProposta"
                id="TiposProposta"
                v-model="tipoProposta"
              ></v-select>
              <br />
            </div>
          </div>

          Digite o percentual:
          <vs-input
            placeholder="Valor"
            v-money="money"
            v-model="percentualDesconto"
            name="Valor do produto"
            id="Valor do produto"
            class="mt-3 mb-2 w-full"
            v-validate="{ required: true, min: 0 }"
            :state="validateState('Valor do produto')"
            :class="validateClass('Valor do produto')"
          />
          <vs-button
            color="success"
            class="w-full mt-2"
            @click="adicionaTipoDeDesconto"
            >Salvar</vs-button
          >
        </div>
      </Modal>
    </form>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from './../../locale';
import * as lang from 'vuejs-datepicker/src/locale';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import service from '../../services';
import BotaoSubmit from '../../components/BotaoSubmit';
import { VMoney, Money } from 'v-money';
import jwt from 'jsonwebtoken';
import functions from '../../utils/functions.js';
import Modal from '../../components/Modal.vue';

export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
  },
  watch: {
    dados() {
      this.preencheForm();
    },
    grupo(value) {
      if (value.length != 0) {
        if (this.formCadastro.isValorFixo == true)
          this.activePromptValor = true;
        else this.adicionaGrupoProduto();
      }
    },
    tiposDescontos(value) {
      if (value.length != 0) {
        this.activePromptDesconto = true;
      } else {
        this.activePromptDesconto = false;
        this.tiposDescontos = '';
      }

      if (value == null) {
        this.tiposDescontos = '';
      }
    },
  },
  data() {
    return {
      money: {
        decimal: '.',
        thousands: '',
        prefix: '',
        suffix: '',
        precision: 2,
      },
      passo: 0,
      activePromptValor: false,
      activePromptDesconto: false,
      aguardeCadastro: false,
      valorGrupo: 0.0,
      percentualDesconto: 0,
      idEmpresa: null,
      grupos: [],
      gruposVeiculos: [],
      formasPagamentos: [],
      tiposDeDescontos: [],
      tiposDescontos: [],
      DescontoEscolhido: [],
      destinos: ['Veículo', 'Associado', 'Dependente'],
      formaPagamento: null,
      languages: lang,
      grupo: [],
      produtos: [],
      produtosEvo: [],
      estados: [],
      estado: [],
      span: '',
      spanEstado: '',
      spanProposta: '',
      estadoString: '',
      fornecedores: [],
      fornecedoresFiltred: [],
      tipoProdutos: [],
      funcoesValicao: null,
      formCadastro: {
        idEmpresa: null,
        isValorFixo: true,
        isServico: false,
        isMensal: null,
        status: true,
        nomeProduto: '',
        nomeProdutoResumo: '',
        obrigatorio: null,
        formasPagamentos: null,
        tiposDeDescontos: null,
        grupos: null,
        porcentagemDescontoMaxima: null,
        visivelProposta: null,
        produtoVisivel: 1,
        alterarValor: null,
        destinos: [],
        produtosLinkados: null,
        sobreporOutrosProdutos: null,
        isAdicional: null,
        requerAssinaturaTermoAdicional: null,
        isDesconto: null,
        idProdutoEvo: null,
        idTipoProduto: null,
        idFornecedor: null,
        estado: null,
        valorBaseadoFipe: null,

        // SEGURADORA
        IOF: null,
        franquia: null,
        valorSegurado: null,
        valorIOF: null,
      },
      tiposProposta: [
        'Adesão',
        'Reativação',
        'Substituição',
        'Inclusão',
        'Troca de Titularidade',
        'Migração',
      ],
      tipoProposta: '',
    };
  },
  directives: { money: VMoney },
  computed: {
    bemProtege() {
      return functions.verificaEmpresaBemProtege(this.idEmpresa);
    },
  },
  methods: {
    selecionaTipo() {
      this.formCadastro.idFornecedor = null;

      if (this.formCadastro.idTipoProduto == 8) {
        this.formCadastro.isDesconto = true;
      } else {
        this.formCadastro.isDesconto = false;
      }
      this.fornecedoresFiltred = this.fornecedores.filter(
        (x) => x.idTipoProduto == this.formCadastro.idTipoProduto,
      );
    },
    exibeValor(valor) {
      var retorno =
        this.formCadastro.isValorFixo == true
          ? this.$options.filters.currency(valor)
          : 'Valor a ser definido na tabela';
      return retorno;
    },
    deletaGrupoVeiculo(idGrupo) {
      let array = this.gruposVeiculos;
      for (var i = array.length - 1; i >= 0; i--) {
        if (array[i].idGrupo == idGrupo) {
          array.splice(i, 1);
        }
      }
    },
    deletaTipoDesconto(idTipoDesconto) {
      let array = this.DescontoEscolhido;

      for (var i = array.length - 1; i >= 0; i--) {
        if (array[i].idTipoDesconto == idTipoDesconto) {
          array.splice(i, 1);
        }
      }
    },
    preencheGrupo() {
      if (this.grupo.length == 0) {
        return '';
      } else {
        return this.grupo.label;
      }
    },
    preencheTipoDesconto() {
      if (this.tiposDescontos.length == 0 || this.tiposDescontos == null) {
        return '';
      } else {
        return (this.tiposDescontos.label = this.tiposDescontos.label
          ? this.tiposDescontos.label
          : '');
      }
    },
    preencheForm() {
      this.gruposVeiculos = [];
      this.DescontoEscolhido = [];
      this.valorGrupo = 0;
      this.percentualDesconto = 0;

      if (this.dados.idProduto) {
        this.formCadastro.valorBaseadoFipe = this.dados.valorBaseadoFipe
          ? parseFloat(this.dados.valorBaseadoFipe).toFixed(2)
          : 0;
        this.formCadastro.idProduto = this.dados.idProduto;
        this.formCadastro.status = this.dados.deletedAt == null ? true : false;

        this.formCadastro.isValorFixo = this.dados.isValorFixo;
        this.formCadastro.isServico = this.dados.isServico;
        this.formCadastro.isMensal = this.dados.isMensal;
        this.formCadastro.nomeProduto = this.dados.nomeProduto;
        this.formCadastro.nomeProdutoResumo = this.dados.nomeProdutoResumo;

        this.formCadastro.obrigatorio = this.dados.obrigatorio;
        this.formCadastro.porcentagemDescontoMaxima =
          this.dados.porcentagemDescontoMaxima;

        this.formCadastro.grupos = this.dados.Grupos;
        this.gruposVeiculos = this.dados.Grupos;

        this.formCadastro.tiposDescontos = this.dados.tiposDescontos;
        this.DescontoEscolhido = this.dados.ProdutosDescontos;

        this.tiposDeDescontos.forEach((element) => {
          this.DescontoEscolhido.forEach((element2) => {
            if (element.id == element2.idTipoDesconto) {
              element2.descricao = element.label;
            }
          });
        });

        this.formCadastro.visivelProposta = this.dados.visivelProposta;
        this.formCadastro.alterarValor = this.dados.alterarValor;
        this.formCadastro.produtoVisivel = this.dados.produtoVisivel;
        this.formCadastro.isAdicional = this.dados.isAdicional;
        this.formCadastro.requerAssinaturaTermoAdicional =
          this.dados.requerAssinaturaTermoAdicional;
        this.formCadastro.isDesconto = this.dados.isDesconto;

        this.formCadastro.idProdutoEvo = this.dados.idProdutoEvo;

        this.formCadastro.idTipoProduto = this.dados.idTipoProduto;
        this.formCadastro.idFornecedor = this.dados.idFornecedor;
        this.fornecedoresFiltred = this.fornecedores.filter(
          (x) => x.idTipoProduto == this.formCadastro.idTipoProduto,
        );

        this.formCadastro.tiposDescontos = this.dados.tiposDescontos;
        this.DescontoEscolhido = this.dados.ProdutosDescontos;

        // SEGURADORA
        this.formCadastro.IOF = this.dados.IOF;
        this.formCadastro.franquia = this.dados.franquia;
        this.formCadastro.valorSegurado = this.dados.valorSegurado;
        this.formCadastro.valorIOF = this.dados.valorIOF;

        if (this.DescontoEscolhido)
          if (this.dados.produtosLinkados) {
            var aux = this.dados.produtosLinkados.split(',');
            var arrProdAux = [];
            aux.forEach((el) => {
              var list = this.produtos.filter((x) => x.id == el)[0];
              if (list) {
                arrProdAux.push(list);
              }
            });
            this.formCadastro.produtosLinkados = arrProdAux;
          } else this.formCadastro.produtosLinkados = [];

        if (this.dados.sobreporOutrosProdutos) {
          let aux = this.dados.sobreporOutrosProdutos.split(',');
          let arrProdAux = [];
          aux.forEach((el) => {
            var list = this.produtos.filter((x) => x.id == el)[0];
            if (list) {
              arrProdAux.push(list);
            }
          });
          this.formCadastro.sobreporOutrosProdutos = arrProdAux;
        } else this.formCadastro.sobreporOutrosProdutos = [];

        var arrAux = [];
        this.dados.TipoPagamento.forEach((element) => {
          arrAux.push({
            id: element.idTipoPagamentoEmpresa,
            label: element.nomePagamento,
          });
        });
        this.formCadastro.formasPagamentos = arrAux;

        const { destinos } = this.dados;

        this.formCadastro.destinos = this.convertSelectData(destinos);
      } else {
        this.resetForm();
      }
    },
    getDecoded() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.decoded = jwt.decode(token);
        this.id_usuario = this.decoded.id_usuario;
        this.idEmpresa = this.decoded.id_empresa;
      }
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    onSubmit() {
      this.formCadastro.idEmpresa = this.idEmpresa;

      const { destinos } = this.formCadastro;
      this.formCadastro.destinos = this.convertSelectData(destinos);

      if (this.formCadastro.idTipoProduto != 1)
        this.formCadastro.valorBaseadoFipe = null;

      if (this.gruposVeiculos.length == 0) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'É Necessário adicionar os Grupos referentes a este Produto',
          color: 'danger',
        });
        return;
      }

      var action = 'Atualizar';
      this.msgRetorno = 'Dados Atualizados com sucesso';
      if (!this.formCadastro.idProduto) {
        action = 'Adicionar';
      }
      this.formCadastro.grupos = this.gruposVeiculos;
      this.formCadastro.tiposDescontos = this.DescontoEscolhido;

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          service
            .post('Produto', action, this.formCadastro)
            .then(() => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: `Operação Realizada com sucesso`,
                color: 'success',
              });
              this.$emit('concluido');
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: error,
                color: 'danger',
              });
            });
        }
      });
    },
    clearFormGrupo() {
      this.activePromptValor = false;
      this.grupo = [];
    },
    clearFormDescontos() {
      this.activePromptValor = false;
      this.tiposDescontos = [];
    },
    adicionaGrupoProduto() {
      this.activePromptValor = false;
      var auxList = this.gruposVeiculos.filter(
        (x) => x.idGrupo == this.grupo.id,
      );
      if (auxList.length == 0)
        this.gruposVeiculos.push({
          idGrupo: this.grupo.id,
          nomeGrupo: this.grupo.label,
          valor:
            this.formCadastro.isValorFixo == true
              ? this.valorGrupo == null || 0
                ? 0
                : this.valorGrupo
              : null,
        });

      this.grupo = [];
      this.valorGrupo = 0;
    },
    adicionaTipoDeDesconto() {
      this.activePromptDesconto = false;

      if (this.tiposDescontos.id == 4 || this.tiposDescontos.id == 5) {
        this.estadoString = this.estado.toString();
        this.DescontoEscolhido.status = this.estadoString;
      }

      if (this.tiposDescontos.id != 2) {
        this.tipoProposta = '';
      } else {
        this.DescontoEscolhido.status = this.tipoProposta;
      }

      var auxList = this.DescontoEscolhido.filter(
        (x) => x.id == this.tiposDescontos.id,
      );
      if (auxList.length == 0)
        this.DescontoEscolhido.push({
          idTipoDesconto: this.tiposDescontos.id,
          descricao: this.tiposDescontos.label,
          percentualMaximoDesconto: this.percentualDesconto,
          tipoProposta: this.tipoProposta,
          estados: this.estadoString,
          idConsultor: this.id_usuario,
          status: this.DescontoEscolhido.status,
        });

      this.DescontoEscolhido.status = '';
      this.tipoProposta = '';
      this.estadoString = '';
      this.percentualDesconto = 0;

      this.tiposDescontos = [];
      this.percentualDesconto = 0;
    },
    buscaDadosGrupos() {
      service.getAll('Grupo', {}, 'list/' + this.idEmpresa).then((res) => {
        res.data.forEach((element) => {
          if (element.deletedAt == null)
            this.grupos.push({
              id: element.idGrupo,
              label: element.nomeGrupo,
            });
        });
      });
    },
    buscaDadosTiposPagamento() {
      service
        .getAll('TipoPagamento', {}, 'list/' + this.idEmpresa)
        .then((res) => {
          res.data.forEach((element) => {
            this.formasPagamentos.push({
              id: element.idTipoPagamentoEmpresa,
              label: element.TipoPagamento_domTipoPagamento.nomePagamento,
            });
          });
        });
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });

        this[array].sort(function (a, b) {
          return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
        });
        this[array].unshift({ id: null, label: 'Selecione' });
      });
    },
    buscaDadosTiposProdutos() {
      service.getAll('g', {}, 'domTipoProdutos/list').then((res) => {
        res.data.forEach((element) => {
          this.tipoProdutos.push({
            id: element.idTipoProduto,
            label: element.nomeTipo,
          });
        });
      });
    },
    buscaDadosFornecedores() {
      service.getAll('g', {}, 'fornecedores/list').then((res) => {
        res.data.forEach((element) => {
          this.fornecedores.push({
            id: element.idFornecedor,
            label: element.nomeFornecedor,
            idTipoProduto: element.idTipoProduto,
          });
        });
        //this.fornecedoresFiltred = [...this.fornecedores];
      });
    },
    buscaDadosTiposDescontos() {
      service.getAll('g', {}, `TiposDescontos/list`).then((res) => {
        res.data.forEach((element) => {
          this.tiposDeDescontos.push({
            id: element.id_tipoDesconto,
            label: element.descricao,
          });
        });
      });
    },
    buscaDadosProdutos() {
      service
        .getAll('g', {}, `produtos/list/idEmpresa/idEmpresa=${this.idEmpresa}`)
        .then((res) => {
          res.data.forEach((element) => {
            this.produtos.push({
              id: element.idProduto,
              label: element.nomeProduto,
            });
          });
        });
    },
    buscaDadosProdutosEvo() {
      service.getAll('Produto', {}, `ListarProdutosEvo`).then((res) => {
        this.produtosEvo = [
          {
            id: null,
            label: 'Selecione',
          },
        ];
        res.data.forEach((element) => {
          this.produtosEvo.push({
            id: element.idProdutoEvo,
            label: element.nomeProduto + ' - ' + element.nomeFornecedor,
          });
        });
      });
    },
    resetForm() {
      this.formCadastro = {
        isValorFixo: null,
        isServico: null,
        isMensal: null,
        status: true,
        nomeProduto: '',
        obrigatorio: null,
        formasPagamentos: null,
        grupos: null,
        porcentagemDescontoMaxima: null,
        visivelProposta: null,
        produtoVisivel: 1,
        produtosLinkados: null,
        sobreporOutrosProdutos: null,
        isAdicional: null,
        requerAssinaturaTermoAdicional: null,
        isDesconto: null,
        idProdutoEvo: null,
        idTipoProduto: null,
        idFornecedor: null,
        tiposDeDescontos: null,
        valorBaseadoFipe: null,
      };
      this.percentualDesconto = 0;
    },
    onReset(evt) {
      if (this.sideBar == true) {
        this.$emit('cancel');
      } else {
        evt.preventDefault();
        this.resetForm();
        this.$nextTick(() => {
          this.show = true;
        });
      }
    },
    convertSelectData(data) {
      data =
        data == undefined || data == null || data.length == 0 || !data
          ? ''
          : data;

      const hasData = data.length;
      const dataType = typeof data;
      if (hasData && dataType === 'string') return data.split(',');

      if (Array.isArray(data)) return data.join(',');

      return data;
    },
  },
  created() {
    this.getDecoded();
  },
  mounted() {
    this.buscaDadosGrupos();
    this.buscaDadosTiposPagamento();
    this.buscaDadosProdutos();
    this.buscaDadosProdutosEvo();
    this.buscaDadosTiposProdutos();
    this.buscaDadosFornecedores();
    this.buscaDadosTiposDescontos();
    this.buscaDadosSelects('domUf', 'estados', 'nomeUf', 'codUf');
    this.$validator.localize('ptBr', locale);
  },
  components: {
    Money,
    BotaoSubmit,
    'v-select': vSelect,
    Modal
  },
};
</script>
<!------------ END SCRIPT ------------>

<style scoped>
.div-show {
  display: 'block';
}
.div-hide {
  display: none;
}

li.activeChild {
  border-bottom: 1px solid rgba(var(--vs-primary), 1) !important;
}

div.firstInputTab {
  margin-top: 20px;
}
</style>
